// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard header (week nav + filter bar) — ported from filtering.html.
   All selectors are scoped under .dashboard-header so they don't leak. */

.dashboard-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0;
  width: 100%;
  font-family: 'Manrope', sans-serif;
}

/* ── Week nav ───────────────────────────────────────────────────────── */
.dashboard-header .week-nav {
  display: flex;
  align-items: center;
  gap: 6px;
}
.dashboard-header .week-nav-btn {
  background: none;
  border: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1c1c1c;
  border-radius: 4px;
  flex-shrink: 0;
  padding: 0;
}
.dashboard-header .week-nav-btn:hover {
  background: #f5f5f5;
}
.dashboard-header .week-nav-btn:disabled {
  color: #bdbdbd;
  cursor: default;
}
.dashboard-header .week-label {
  font-size: 16px;
  font-weight: 600;
  color: #1c1c1c;
  white-space: nowrap;
}

/* ── Filter bar ─────────────────────────────────────────────────────── */
.dashboard-header .filter-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  gap: 16px;
  flex-wrap: wrap;
}
.dashboard-header .filter-groups {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.dashboard-header .filter-group {
  display: flex;
  align-items: center;
  border: 1px solid #DADADA;
  border-radius: 8px;
  height: 32px;
  overflow: visible;
  position: relative;
}
.dashboard-header .filter-group-icon {
  width: 36px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #979797;
}
.dashboard-header .filter-group-icon img {
  width: 36px;
  height: 20px;
  object-fit: contain;
}

.dashboard-header .pill-wrap {
  position: relative;
}

.dashboard-header .filter-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  width: 140px;
  flex-shrink: 0;
  padding: 0 4px 0 8px;
  border-left: 1px solid #DADADA;
  cursor: pointer;
  background: none;
  border-top: none;
  border-right: none;
  border-bottom: none;
  font-family: 'Manrope', sans-serif;
  text-align: left;
  outline: none;
}
.dashboard-header .filter-pill:focus-visible {
  outline: 2px solid #44a735;
  outline-offset: -2px;
}

.dashboard-header .filter-pill .chip-plain {
  font-size: 14px;
  font-weight: 400;
  color: #1C1C1C;
  white-space: nowrap;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dashboard-header .filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #e7f4e6;
  border: 1px solid #a7daa1;
  border-radius: 8px;
  padding: 2px 8px;
  font-size: 14px;
  color: #1c1c1c;
  white-space: nowrap;
  font-weight: 400;
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
}
.dashboard-header .filter-chip-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1 1 0;
}
.dashboard-header .filter-chip-more {
  flex-shrink: 0;
  white-space: nowrap;
}
.dashboard-header .chip-x {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
  background: none;
  border: none;
  padding: 0;
  color: #1c1c1c;
}

.dashboard-header .filter-pill-chevron {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #979797;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── Reset filters ──────────────────────────────────────────────────── */
.dashboard-header .reset-filters {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #2E8722;
  cursor: pointer;
  background: none;
  border: none;
  font-family: 'Manrope', sans-serif;
  font-weight: 400;
  padding: 2px 0;
  white-space: nowrap;
}
.dashboard-header .reset-filters:hover:not(:disabled) {
  text-decoration: underline;
}
.dashboard-header .reset-filters:disabled {
  color: #BDBDBD;
  cursor: default;
  pointer-events: none;
}

/* ── Dropdown panel ─────────────────────────────────────────────────── */
.dashboard-header .dropdown-panel {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  background: #fcfcfc;
  border: 1px solid #dadada;
  border-radius: 8px;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.06);
  min-width: 220px;
  max-width: calc(100vw - 16px);
  z-index: 300;
  padding: 12px 0;
}
.dashboard-header .dropdown-panel.align-right {
  left: auto;
  right: 0;
}
/* Viewport-pinned placement: used when the panel can't fit anchored to either
   side of its trigger pill (typically the wide client picker on a phone). The
   inline \`top\` (set in JS) carries the pill's bottom + 6px in viewport coords. */
.dashboard-header .dropdown-panel.fixed-pin {
  position: fixed;
  left: 8px;
  right: 8px;
  width: auto;
  max-width: none;
}

.dashboard-header .dropdown-option {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 36px;
  padding: 0 12px;
  font-size: 14px;
  color: #1c1c1c;
  cursor: pointer;
  transition: background 0.1s;
  user-select: none;
}
.dashboard-header .dropdown-option:hover {
  background: #f5f5f5;
}

.dashboard-header .dropdown-check {
  width: 20px;
  height: 20px;
  border: 1.5px solid #dadada;
  border-radius: 6px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.dashboard-header .dropdown-check.checked,
.dashboard-header .dropdown-check.indeterminate {
  background: #44a735;
  border-color: #44a735;
}

.dashboard-header .dropdown-divider {
  height: 1px;
  background: #ececec;
  margin: 6px 8px;
}

.dashboard-header .dropdown-section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #979797;
  padding: 4px 12px 4px;
}

.dashboard-header .dropdown-footer {
  border-top: 1px solid #eaeaea;
  padding: 16px 12px 0;
  margin-top: 4px;
}
.dashboard-header .dropdown-apply {
  width: 100%;
  padding: 8px 12px;
  border: 1.5px solid #44a735;
  border-radius: 8px;
  background: transparent;
  font-family: 'Manrope', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #2e8722;
  cursor: pointer;
  text-align: center;
}
.dashboard-header .dropdown-apply:hover {
  background: #e7f4e6;
}

/* ── Dropdown search (skills/clients) ───────────────────────────────── */
.dashboard-header .dropdown-search {
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #dadada;
  padding: 0 12px 8px;
  height: 32px;
  flex-shrink: 0;
}
.dashboard-header .dropdown-search input {
  border: none;
  outline: none;
  font-family: 'Manrope', sans-serif;
  font-size: 14px;
  color: #1c1c1c;
  background: transparent;
  flex: 1;
  min-width: 0;
}
.dashboard-header .dropdown-search input::placeholder {
  color: #979797;
}

.dashboard-header .dropdown-scroll {
  overflow-y: auto;
  max-height: min(264px, calc(100vh - 220px));
  padding-top: 4px;
}

/* ── Client + billing two-column dropdown ───────────────────────────── */
.dashboard-header .client-panel {
  padding: 12px;
  width: 580px;
  max-width: calc(100vw - 32px);
}
.dashboard-header .client-two-col {
  display: flex;
  gap: 16px;
  align-items: stretch;
  min-width: 0;
}
.dashboard-header .client-col {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
}
.dashboard-header .client-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.1s;
  width: 100%;
  min-width: 0;
}
.dashboard-header .client-row:hover:not(.selected) {
  background: #f5f5f5;
}
.dashboard-header .client-row.selected {
  background: #e7f4e6;
}
.dashboard-header .client-row-text {
  display: flex;
  flex-direction: column;
  line-height: 1.4;
  flex: 1;
  min-width: 0;
}
.dashboard-header .client-row-name {
  font-size: 14px;
  font-weight: 400;
  color: #1c1c1c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dashboard-header .client-row-count {
  font-size: 12px;
  font-weight: 400;
  color: #5b5b5b;
  white-space: nowrap;
}
.dashboard-header .client-row-chevron {
  flex-shrink: 0;
  color: #dadada;
  transition: color 0.1s;
}
.dashboard-header .client-row.selected .client-row-chevron {
  color: #44a735;
}

.dashboard-header .billing-col {
  width: 249px;
  flex-shrink: 0;
  background: #fafafa;
  border: 1px solid #dadada;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 12px 0 12px 16px;
  min-height: 180px;
}
.dashboard-header .billing-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 8px;
  color: #979797;
  font-size: 14px;
  text-align: center;
  padding-right: 16px;
}
.dashboard-header .billing-title {
  font-size: 12px;
  font-weight: 600;
  color: #1c1c1c;
  height: 32px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dadada;
  flex-shrink: 0;
  padding-right: 12px;
}
.dashboard-header .billing-list {
  overflow-y: auto;
  max-height: min(216px, calc(100vh - 260px));
  padding-top: 4px;
}
.dashboard-header .billing-list .dropdown-option {
  padding-left: 0;
  padding-right: 8px;
}
.dashboard-header .billing-list.locked .dropdown-option {
  opacity: 0.4;
  pointer-events: none;
  cursor: default;
}

.dashboard-header .client-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 16px;
  margin-top: 12px;
  border-top: 1px solid #eaeaea;
}
.dashboard-header .client-footer-count {
  font-size: 12px;
  font-weight: 500;
  color: #5b5b5b;
}
.dashboard-header .client-footer-clear {
  background: none;
  border: none;
  font-family: 'Manrope', sans-serif;
  font-size: 12px;
  color: #979797;
  cursor: pointer;
  padding: 4px 0;
}
.dashboard-header .client-footer-clear.active {
  color: #2e8722;
}

/* ── Mobile / narrow viewport ───────────────────────────────────────── */
@media (max-width: 600px) {
  /* Client picker — stack the two-column layout vertically so neither pane
     gets squeezed under the panel's \`calc(100vw - 32px)\` cap. */
  .dashboard-header .client-panel {
    width: calc(100vw - 16px);
    max-width: calc(100vw - 16px);
  }
  .dashboard-header .client-two-col {
    flex-direction: column;
    gap: 12px;
  }
  .dashboard-header .billing-col {
    width: auto;
    min-height: 0;
    padding: 8px 0 8px 12px;
  }
  .dashboard-header .billing-list {
    max-height: min(180px, calc(100vh - 360px));
  }
  .dashboard-header .billing-empty {
    min-height: 80px;
    padding: 8px 12px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/routes/Agency/Dashboard/DashboardHeader/index.css"],"names":[],"mappings":"AAAA;yEACyE;;AAEzE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,WAAW;EACX,kCAAkC;AACpC;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;EAC/C,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;AACA;EACE,UAAU;EACV,QAAQ;AACV;AACA;;iFAEiF;AACjF;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,OAAO;EACP,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,QAAQ;EACR,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE;gEAC8D;EAC9D;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":["/* Dashboard header (week nav + filter bar) — ported from filtering.html.\n   All selectors are scoped under .dashboard-header so they don't leak. */\n\n.dashboard-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 0;\n  width: 100%;\n  font-family: 'Manrope', sans-serif;\n}\n\n/* ── Week nav ───────────────────────────────────────────────────────── */\n.dashboard-header .week-nav {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.dashboard-header .week-nav-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #1c1c1c;\n  border-radius: 4px;\n  flex-shrink: 0;\n  padding: 0;\n}\n.dashboard-header .week-nav-btn:hover {\n  background: #f5f5f5;\n}\n.dashboard-header .week-nav-btn:disabled {\n  color: #bdbdbd;\n  cursor: default;\n}\n.dashboard-header .week-label {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1c1c1c;\n  white-space: nowrap;\n}\n\n/* ── Filter bar ─────────────────────────────────────────────────────── */\n.dashboard-header .filter-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n.dashboard-header .filter-groups {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.dashboard-header .filter-group {\n  display: flex;\n  align-items: center;\n  border: 1px solid #DADADA;\n  border-radius: 8px;\n  height: 32px;\n  overflow: visible;\n  position: relative;\n}\n.dashboard-header .filter-group-icon {\n  width: 36px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #979797;\n}\n.dashboard-header .filter-group-icon img {\n  width: 36px;\n  height: 20px;\n  object-fit: contain;\n}\n\n.dashboard-header .pill-wrap {\n  position: relative;\n}\n\n.dashboard-header .filter-pill {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 32px;\n  width: 140px;\n  flex-shrink: 0;\n  padding: 0 4px 0 8px;\n  border-left: 1px solid #DADADA;\n  cursor: pointer;\n  background: none;\n  border-top: none;\n  border-right: none;\n  border-bottom: none;\n  font-family: 'Manrope', sans-serif;\n  text-align: left;\n  outline: none;\n}\n.dashboard-header .filter-pill:focus-visible {\n  outline: 2px solid #44a735;\n  outline-offset: -2px;\n}\n\n.dashboard-header .filter-pill .chip-plain {\n  font-size: 14px;\n  font-weight: 400;\n  color: #1C1C1C;\n  white-space: nowrap;\n  flex: 1 1 0;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dashboard-header .filter-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #e7f4e6;\n  border: 1px solid #a7daa1;\n  border-radius: 8px;\n  padding: 2px 8px;\n  font-size: 14px;\n  color: #1c1c1c;\n  white-space: nowrap;\n  font-weight: 400;\n  flex: 1 1 0;\n  min-width: 0;\n  max-width: 100%;\n}\n.dashboard-header .filter-chip-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  flex: 1 1 0;\n}\n.dashboard-header .filter-chip-more {\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n.dashboard-header .chip-x {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  flex-shrink: 0;\n  background: none;\n  border: none;\n  padding: 0;\n  color: #1c1c1c;\n}\n\n.dashboard-header .filter-pill-chevron {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: #979797;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ── Reset filters ──────────────────────────────────────────────────── */\n.dashboard-header .reset-filters {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 14px;\n  color: #2E8722;\n  cursor: pointer;\n  background: none;\n  border: none;\n  font-family: 'Manrope', sans-serif;\n  font-weight: 400;\n  padding: 2px 0;\n  white-space: nowrap;\n}\n.dashboard-header .reset-filters:hover:not(:disabled) {\n  text-decoration: underline;\n}\n.dashboard-header .reset-filters:disabled {\n  color: #BDBDBD;\n  cursor: default;\n  pointer-events: none;\n}\n\n/* ── Dropdown panel ─────────────────────────────────────────────────── */\n.dashboard-header .dropdown-panel {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  background: #fcfcfc;\n  border: 1px solid #dadada;\n  border-radius: 8px;\n  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.06);\n  min-width: 220px;\n  max-width: calc(100vw - 16px);\n  z-index: 300;\n  padding: 12px 0;\n}\n.dashboard-header .dropdown-panel.align-right {\n  left: auto;\n  right: 0;\n}\n/* Viewport-pinned placement: used when the panel can't fit anchored to either\n   side of its trigger pill (typically the wide client picker on a phone). The\n   inline `top` (set in JS) carries the pill's bottom + 6px in viewport coords. */\n.dashboard-header .dropdown-panel.fixed-pin {\n  position: fixed;\n  left: 8px;\n  right: 8px;\n  width: auto;\n  max-width: none;\n}\n\n.dashboard-header .dropdown-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 36px;\n  padding: 0 12px;\n  font-size: 14px;\n  color: #1c1c1c;\n  cursor: pointer;\n  transition: background 0.1s;\n  user-select: none;\n}\n.dashboard-header .dropdown-option:hover {\n  background: #f5f5f5;\n}\n\n.dashboard-header .dropdown-check {\n  width: 20px;\n  height: 20px;\n  border: 1.5px solid #dadada;\n  border-radius: 6px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n.dashboard-header .dropdown-check.checked,\n.dashboard-header .dropdown-check.indeterminate {\n  background: #44a735;\n  border-color: #44a735;\n}\n\n.dashboard-header .dropdown-divider {\n  height: 1px;\n  background: #ececec;\n  margin: 6px 8px;\n}\n\n.dashboard-header .dropdown-section-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #979797;\n  padding: 4px 12px 4px;\n}\n\n.dashboard-header .dropdown-footer {\n  border-top: 1px solid #eaeaea;\n  padding: 16px 12px 0;\n  margin-top: 4px;\n}\n.dashboard-header .dropdown-apply {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1.5px solid #44a735;\n  border-radius: 8px;\n  background: transparent;\n  font-family: 'Manrope', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2e8722;\n  cursor: pointer;\n  text-align: center;\n}\n.dashboard-header .dropdown-apply:hover {\n  background: #e7f4e6;\n}\n\n/* ── Dropdown search (skills/clients) ───────────────────────────────── */\n.dashboard-header .dropdown-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-bottom: 1px solid #dadada;\n  padding: 0 12px 8px;\n  height: 32px;\n  flex-shrink: 0;\n}\n.dashboard-header .dropdown-search input {\n  border: none;\n  outline: none;\n  font-family: 'Manrope', sans-serif;\n  font-size: 14px;\n  color: #1c1c1c;\n  background: transparent;\n  flex: 1;\n  min-width: 0;\n}\n.dashboard-header .dropdown-search input::placeholder {\n  color: #979797;\n}\n\n.dashboard-header .dropdown-scroll {\n  overflow-y: auto;\n  max-height: min(264px, calc(100vh - 220px));\n  padding-top: 4px;\n}\n\n/* ── Client + billing two-column dropdown ───────────────────────────── */\n.dashboard-header .client-panel {\n  padding: 12px;\n  width: 580px;\n  max-width: calc(100vw - 32px);\n}\n.dashboard-header .client-two-col {\n  display: flex;\n  gap: 16px;\n  align-items: stretch;\n  min-width: 0;\n}\n.dashboard-header .client-col {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0;\n  min-width: 0;\n}\n.dashboard-header .client-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.1s;\n  width: 100%;\n  min-width: 0;\n}\n.dashboard-header .client-row:hover:not(.selected) {\n  background: #f5f5f5;\n}\n.dashboard-header .client-row.selected {\n  background: #e7f4e6;\n}\n.dashboard-header .client-row-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.4;\n  flex: 1;\n  min-width: 0;\n}\n.dashboard-header .client-row-name {\n  font-size: 14px;\n  font-weight: 400;\n  color: #1c1c1c;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dashboard-header .client-row-count {\n  font-size: 12px;\n  font-weight: 400;\n  color: #5b5b5b;\n  white-space: nowrap;\n}\n.dashboard-header .client-row-chevron {\n  flex-shrink: 0;\n  color: #dadada;\n  transition: color 0.1s;\n}\n.dashboard-header .client-row.selected .client-row-chevron {\n  color: #44a735;\n}\n\n.dashboard-header .billing-col {\n  width: 249px;\n  flex-shrink: 0;\n  background: #fafafa;\n  border: 1px solid #dadada;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  padding: 12px 0 12px 16px;\n  min-height: 180px;\n}\n.dashboard-header .billing-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  gap: 8px;\n  color: #979797;\n  font-size: 14px;\n  text-align: center;\n  padding-right: 16px;\n}\n.dashboard-header .billing-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1c1c1c;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #dadada;\n  flex-shrink: 0;\n  padding-right: 12px;\n}\n.dashboard-header .billing-list {\n  overflow-y: auto;\n  max-height: min(216px, calc(100vh - 260px));\n  padding-top: 4px;\n}\n.dashboard-header .billing-list .dropdown-option {\n  padding-left: 0;\n  padding-right: 8px;\n}\n.dashboard-header .billing-list.locked .dropdown-option {\n  opacity: 0.4;\n  pointer-events: none;\n  cursor: default;\n}\n\n.dashboard-header .client-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding-top: 16px;\n  margin-top: 12px;\n  border-top: 1px solid #eaeaea;\n}\n.dashboard-header .client-footer-count {\n  font-size: 12px;\n  font-weight: 500;\n  color: #5b5b5b;\n}\n.dashboard-header .client-footer-clear {\n  background: none;\n  border: none;\n  font-family: 'Manrope', sans-serif;\n  font-size: 12px;\n  color: #979797;\n  cursor: pointer;\n  padding: 4px 0;\n}\n.dashboard-header .client-footer-clear.active {\n  color: #2e8722;\n}\n\n/* ── Mobile / narrow viewport ───────────────────────────────────────── */\n@media (max-width: 600px) {\n  /* Client picker — stack the two-column layout vertically so neither pane\n     gets squeezed under the panel's `calc(100vw - 32px)` cap. */\n  .dashboard-header .client-panel {\n    width: calc(100vw - 16px);\n    max-width: calc(100vw - 16px);\n  }\n  .dashboard-header .client-two-col {\n    flex-direction: column;\n    gap: 12px;\n  }\n  .dashboard-header .billing-col {\n    width: auto;\n    min-height: 0;\n    padding: 8px 0 8px 12px;\n  }\n  .dashboard-header .billing-list {\n    max-height: min(180px, calc(100vh - 360px));\n  }\n  .dashboard-header .billing-empty {\n    min-height: 80px;\n    padding: 8px 12px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
